// Lightweight typed wrapper around redux-injector to avoid TS type issues
// eslint-disable-next-line @typescript-eslint/no-var-requires
const injector = require('redux-injector');

export const createInjectStore: (
  initialReducers: any,
  preloadedState?: any,
  enhancer?: any
) => any = injector.createInjectStore;

export const injectReducer: (
  key: string | string[],
  reducer: any,
  force?: boolean
) => void = injector.injectReducer;